import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  apidata,
  columns,
  totalRecords,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setStatusFilter("");

    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder="Search by name"
            className="form-control"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={apidata}
        pagination
        fixedHeader
        highlightOnHover
        responsive
        paginationServer
        paginationTotalRows={totalRecords}
        paginationPerPage={rowsPerPage}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(newPerPage) => {
          setRowsPerPage(newPerPage);
          setCurrentPage(1);
        }}
      />

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        applyFilters={() => {
          setCurrentPage(1);
          setShowFilterModal(false);
        }}
        removeFilters={() => {
          setStatusFilter("");
          setCurrentPage(1);
          setShowFilterModal(false);
        }}
      />
    </div>
  );
}
